import { createSectionCreator, createField } from '../utils'
import { checker } from '../selectors'

const reasonInputField = (id) =>
  createField(`${id}.detail`, [
    {
      label: 'โปรดระบุรายละเอียด',
      id: `${id}.detail`,
      c: 'TextInput',
      p: {},
    },
  ])

const getQuestions = (app, id) => {
  const { isYes } = checker(app)
  return [
    createField(`${id}.treatmentSIO.label`, [
      {
        id: `${id}.treatment.label`,
        c: 'PlainText',
        p: {
          children:
            'ท่านเคยได้รับการวินิจฉัย หรือรับการรักษา หรือตั้งข้อสังเกตจากแพทย์ว่าป่วยเป็นโรค ตามรายการท้ายคำถามนี้หรือไม่',
        },
      },
    ]),
    createField(`${id}.treatmentSIO.a.checked`, [
      {
        id: `${id}.treatmentSIO.a.checked`,
        c: 'RadioButton',
        required: true,
        label:
          'โรคความดันโลหิตสูง โรคหลอดเลือดในสมอง โรคเบาหวาน โรคหัวใจ โรคเลือด โรคหลอดเลือด โรคมะเร็ง เนื้องอก ก้อน หรือถุงน้ำ โรคไต โรคเอสแอลอี โรคเอดส์ หรือภูมิคุ้มกันบกพร่อง โรควัณโรค พิการทางร่างกาย โรคหอบหืด โรคปอดหรือปอดอักเสบ โรคตับหรือทางเดินน้ำดี',
        p: {
          options: [
            {
              text: 'ใช่',
              value: 'yes',
            },
            {
              text: 'ไม่ใช่',
              value: 'no',
            },
          ],
        },
      },
    ]),
    isYes(`${id}.treatmentSIO.a.checked`) && reasonInputField(`${id}.treatmentSIO.a`),
    createField(`${id}.treatmentSIO.b.checked`, [
      {
        id: `${id}.treatmentSIO.b.checked`,
        c: 'RadioButton',
        required: true,
        label:
          'ภายในระยะเวลา 12 เดือนที่ผ่านมา ท่านเคยบาดเจ็บ หรือเจ็บป่วยจนต้องเข้ารับการรักษาในโรงพยาบาล หรือเคยได้รับการตรวจเพื่อวินิจฉัยโรค หรือรับการผ่าตัด หรือการแนะนำจากแพทย์แผนปัจจุบันหรือแพทย์ทางเลือกเพื่อรับการรักษาใด ๆ หรือไม่',
        p: {
          options: [
            {
              text: 'ใช่',
              value: 'yes',
            },
            {
              text: 'ไม่ใช่',
              value: 'no',
            },
          ],
        },
      },
    ]),
    isYes(`${id}.treatmentSIO.b.checked`) && reasonInputField(`${id}.treatmentSIO.b`),
    createField(
      `${id}.treatmentSIO.label2`,
      [
        {
          id: `${id}.treatmentSIO.label2`,
          label: 'สำหรับผู้ขอเอาประกันภัย กรณีต้องการแจ้งรายละเอียดเพิ่มเติม',
          c: 'PlainText',
          p: {
            children: '',
          },
        },
      ],
      {
        style: {
          marginBottom: '0',
        },
      }
    ),
    reasonInputField(`${id}.treatmentSIO.other`),
  ]
}

export default createSectionCreator(getQuestions)
